import { A } from '@mobily/ts-belt';
import { Box, FormHelperText, List, ListItem } from '@mui/material';
import { Link, useTranslate } from 'react-admin';

import { AllocationRecord } from '@sh4res/bo-common/components/B2bCampaigns/steps/allocations/AllocationsConfirmationStep';
import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { buildLink } from '@sh4res/bo-common/utils/build_link';

type Props = {
  invalidEmployees: (Pick<AllocationRecord, 'firstname' | 'lastname' | 'identifier'> & {
    error: string;
  })[];
};

export const InvalidCampaignEmployeesSection = ({ invalidEmployees }: Props) => {
  const translate = useTranslate();
  const resourceBasePath = useResourceBasePath();

  if (A.isEmpty(invalidEmployees)) {
    return null;
  }

  return (
    <Box sx={{ overflowY: 'auto', maxHeight: '150px' }}>
      <FormHelperText error sx={{ fontSize: 14 }}>
        {translate(
          'resources.bo_common.b2b.campaigns.sections.review.errors.invalid_employee_allocations',
        )}
        :
        <List dense disablePadding>
          {invalidEmployees.map((employee, index) => (
            <ListItem key={index} sx={{ display: 'list-item', pl: 2 }}>
              {`${employee.identifier} - ${employee.firstname} ${employee.lastname} : ${translate(`resources.bo_common.b2b.campaigns.sections.review.errors.${employee.error}`)}`}
            </ListItem>
          ))}
        </List>
      </FormHelperText>
      <Link fontSize={14} target="_blank" to={buildLink(`${resourceBasePath}employees`, 'list')}>
        {translate(
          'resources.bo_common.b2b.campaigns.sections.review.errors.missing_employees_link',
        )}
      </Link>
    </Box>
  );
};
